import styled from 'styled-components';

export const NoBorderAndSubtextWrapper = styled.div``;
